import { CircleFlag } from 'react-circle-flags';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    gap: ${spacing.sm};
    align-items: center;
  `}
`;

export const CombinedFlags = styled.div`
  position: relative;
  &:after {
    clip-path: rect(10px, 20px, 30px, 40px);
  }
`;

export const OverlaidCircleFlag = styled(CircleFlag)`
  position: absolute;
  top: 0;
  left: 0;
  clip-path: polygon(100% 0, 0% 100%, 100% 100%);
`;
